import React 			from 'react';
import ReactDOM 		from 'react-dom';
import moment 			from 'moment';
import Slider from 'react-slick';

import BLComponent		from '../../core/_BLComponent.jsx';

import CrowdNavigation 	from './../common/_CrowdNavigation.jsx';
import CrowdfundingCountdown 	from './../common/_CrowdfundingCountdown.jsx';
import CountdownIntroBlock 	from './../common/_CountdownIntroBlock.jsx';
import BDPHeader 	from './../common/_BDPHeader.jsx';
import BDPVideoGalleryBlock 	from './../common/_BDPVideoGalleryBlock.jsx';
import SeriesInternalNav from './../common/_SeriesInternalNav.jsx';
import BDPSubmissionCard from './../common/_BDPSubmissionCard.jsx';
import {bdpDateFormatShort, bdpDateFormatLong} from './../common/_BDPUtilities.jsx';

import StudioActivityContent from '../../studio/_StudioActivityContent.jsx';

import CrowdfundingActiveEnded 	from './../common/landing-highlight-blocks/_CrowdfundingActiveEnded.jsx';
import BuildingInstructionsModalWithDownload 	from '../../modals/_BuildingInstructionsModalWithDownload.jsx';

export default class CrowdLanding extends BLComponent {
	constructor (props, context) {
		super(props, context);

		this.state = {
			activeSlide: 0,
			showInstructions: false,
			instructions: {}
		}

		this.series = blapp.models.get('listSeries') || [];
		this.crowdData = blapp.models.get('crowdData') || [];
		this.finalists = blapp.models.get('submissions_finalists') || [];
		this.instructions = blapp.models.get('instructions') || [];
		this.upcomingSeries = blapp.models.get('upcoming_series') != null ? blapp.models.get('upcoming_series').data : null;

		this.preCrowdfundingSeries = this.series.filter(series => blapp.config.server_time >= series.udtCrowdFundingAnnouncement && blapp.config.server_time <= series.udtCrowdFundingStart);
		this.crowdfundingSeries = this.series.filter(series => blapp.config.server_time >= series.udtCrowdFundingStart && blapp.config.server_time <= moment(series.udtCrowdFundingEnd).add(7, 'days'));
		this.designsAnnouncedSeries = this.series.filter(series => blapp.config.server_time >= series.udtDesignsAnnounced && blapp.config.server_time <= moment(series.udtDesignsAnnounced).add(30, 'days'));
		this.instructionsSeries = this.series.filter(series => blapp.config.server_time >= moment(series.udtProductionStart).subtract(7, 'days') && blapp.config.server_time <= moment(series.udtProductionStart).add(7, 'days'));
		
		this.slickSettings = {
			dots: true,
			arrows: false,
			infinite: false,
			slidesToShow: 1,
			slidesToScroll: 1,
		}

		this.slickSettingsUpcoming = {
			dots: false,
			arrows: false,
			slidesToShow: 2,
			slidesToScroll: 2,
			infinite: false,
			beforeChange: (current, next) => this.setState({activeSlide: next}),
			responsive: [
				{
					breakpoint: 568,
					settings: {
						dots: false,
						arrows:false,
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		}
	}

	render() {
		return (
			<React.Fragment>
				{!blapp.config.isDesktopMode() ? <CrowdNavigation page={1}/> : null}
				{this.state.showInstructions ? <BuildingInstructionsModalWithDownload pdfUrl={this.state.instructions.strURL} fileSize={this.state.instructions.nFileSize} idModel={this.state.instructions.idSubmission} closeFunc={() => this.toggleInstructionsModal(null)}/> : null}
				<BDPHeader classes="bdp-series-main__header--landing-page"/>
				<SeriesInternalNav classes="bdp-series-main__series-nav-landing"/>
				{this.renderHighlightBlock()}
				<div className="main l-margin-bottom--sxl">
					<div className="main__content">
						<div className="edge-to-edge-container bdp-series-main__finalist-container">
							<div className="edge-to-edge-container__internal">
								{this.renderHighlightSeriesBlock()}
							</div>
						</div>
						{this.renderPastSeries()}
						{this.renderUpcomingCrowdfunding()}
						{this.renderPastPrograms()}
					</div>
				</div>
			</React.Fragment>
		);
	}

	renderHighlightBlock() {
		return (
			<section className="bdp-series-main__highlight-block">
				<div className="bdp-series-main__highlight-block-internal">
					<div className="bdp-series-main__highlight-block-content">
						<div className="bdp-series-main__highlight-block-header">
							<i className="bdp-series-main__highlight-block-header-icon far fa-calendar-star"/>
							<div>
								<h2 className="text--xl-title text--bold text--tight">Mark your calendar!</h2>
								<p className="text--title bdp-series-main__announcement-intro--finalists-landing">Submission intake for future Series begins</p>
							</div>
						</div>

						<div className="bdp-series-main__calendar-items">
							<div className={`bdp-series-main__calendar-item bdp-series-main__calendar-item--active`}>
								<div className="bdp-series-main__calendar-item-meta-title">{this.upcomingSeries.strUpcoming1Name}<i className="fas fa-chevrons-left l-margin-left--sm text--small-title"/></div>
								<div className="bdp-series-main__calendar-item-meta-date">{bdpDateFormatShort(this.upcomingSeries.udtUpcoming1)}</div>
							</div>
							<div className={`bdp-series-main__calendar-item`}>
								<div className="bdp-series-main__calendar-item-meta-title">{this.upcomingSeries.strUpcoming2Name}</div>
								<div className="bdp-series-main__calendar-item-meta-date">{bdpDateFormatShort(this.upcomingSeries.udtUpcoming2)}</div>
							</div>
							<div className={`bdp-series-main__calendar-item`}>
								<div className="bdp-series-main__calendar-item-meta-title">{this.upcomingSeries.strUpcoming3Name}</div>
								<div className="bdp-series-main__calendar-item-meta-date">{bdpDateFormatShort(this.upcomingSeries.udtUpcoming3)}</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		);
	}

	renderHighlightSeriesBlock() {
		const seriesContent = 
				this.crowdfundingSeries.length ? 
					this.crowdfundingSeries[0] 
				: this.preCrowdfundingSeries.length ? 
					this.preCrowdfundingSeries[0] 
				: this.designsAnnouncedSeries.length && !this.isUpcoming(this.designsAnnouncedSeries[0]) ? 
					this.designsAnnouncedSeries[0]
				: this.series[0];

		const seriesFinalists = this.finalists.data.submissions.filter(submission => submission.dmBDPSeries.idSeries == seriesContent.idSeries);
		const finalistCards 	= seriesFinalists.map(submission => <BDPSubmissionCard data={submission} key={submission.idSubmission} hasVoting={false} salesInfo={this.crowdData.filter(item => item.idSubmission == submission.idSubmission)[0]} hasPricing={this.preCrowdfundingSeries.length} classes="bdp-series-submissions__card"/>); 
		const showActivity = seriesContent.bShowActivity;
		const activitySlug = showActivity ? seriesContent.dmActivity.strWebSlug : null;

		if(this.crowdfundingSeries.length) {
			return <CrowdfundingActiveEnded isLanding showActivity={showActivity} activitySlug={activitySlug} seriesContent={seriesContent} finalists={seriesFinalists} crowdData={this.crowdData}/>
		}else if(this.preCrowdfundingSeries.length) {
			return (
				<section className="bdp-series-main__home-block">
					<div className="bdp-series-main__pre-crowd-header">
						<div className="bdp-series-main__pre-crowd-title">
							<h1 className="bdp-series-main__announcement-sub bdp-series-main__announcement-sub--finalists-landing bdp-series-main__announcement-sub--pre-crowd text--uppercase">{seriesContent.strName}</h1>
							<h2 className="bdp-series-main__announcement-title l-margin-bottom--sm">Get ready to pre-order your favorite {seriesContent.strName} sets!</h2>
							<p className="bdp-series-main__announcement-intro bdp-series-main__announcement-intro--finalists-landing">Pre-ordering starts on {bdpDateFormatLong(seriesContent.udtCrowdFundingStart)} Pacific time.</p>
						</div>
						<div className="bdp-series-main__pre-crowd-clock-container text--center">
							<h2 className="text--bold l-margin-bottom--sm text--title">Crowdfunding starts in</h2>
							<CrowdfundingCountdown classes="bdp-series-main__clock bdp-series-main__clock--dark l-margin-bottom--xs" end={seriesContent.udtCrowdFundingStart}/>
						</div>
					</div>
					<section className="bdp-series-submissions__card-container bdp-series-submissions__card-container--finalists-landing">
						{finalistCards}
					</section>
					<a href={blapp.url2.getCrowdSeriesUrl(seriesContent.strSlug)} className="btn bg-color--white text-color--darkestBlue text--small-title text--bold bdp-series-main__announcement-link">Go to {seriesContent.strName}<i className="fas fa-long-arrow-right l-margin-left"/></a>
					<BDPVideoGalleryBlock finalists={seriesFinalists} seriesContent={seriesContent}/>
					{showActivity ? this.renderActivity(activitySlug) : null}
				</section>
			);
		}else if(seriesFinalists.length) {		
			return (
				<section className="bdp-series-main__home-block">
					<h1 className="bdp-series-main__announcement-sub bdp-series-main__announcement-sub--finalists-landing text--uppercase">{seriesContent.strName}</h1>
					<h2 className="bdp-series-main__announcement-title l-margin-bottom--sm">Our five {seriesContent.strName} finalists!</h2>
					<p className="bdp-series-main__announcement-intro bdp-series-main__announcement-intro--finalists-landing">These designs are chosen for Crowdfunding on {bdpDateFormatLong(seriesContent.udtCrowdFundingStart)} Pacific time.</p>
					<section className="bdp-series-submissions__card-container bdp-series-submissions__card-container--finalists-landing">
						{finalistCards}
					</section>
					<a href={blapp.url2.getCrowdSeriesUrl(seriesContent.strSlug)} className="btn bg-color--white text-color--darkestBlue text--small-title text--bold bdp-series-main__announcement-link">Go to {seriesContent.strName}<i className="fas fa-long-arrow-right l-margin-left"/></a>
				</section>
			);
		}else if(this.instructionsSeries.length) {
			const instructionsFinalists = this.finalists.data.submissions.filter(submission => submission.dmBDPSeries.idSeries == this.instructionsSeries[0].idSeries);
			const instructionsCards = instructionsFinalists.map(submission => <BDPSubmissionCard data={submission} key={submission.idSubmission} hasVoting={false} salesInfo={this.crowdData.filter(item => item.idSubmission == submission.idSubmission)[0]} hasPricing={false} hasInstructions={this.instructions.findIndex(item => item.idSubmission == submission.idSubmission) != -1} instructionsModal={(id) => this.toggleInstructionsModal(id)} classes="bdp-series-submissions__card"/>); 

			return (
				<section className="bdp-series-main__home-block">
					<h1 className="bdp-series-main__announcement-sub bdp-series-main__announcement-sub--finalists-landing text--uppercase">{this.instructionsSeries[0].strName}</h1>
					<h2 className="bdp-series-main__announcement-title l-margin-bottom--sm">Get ready to start building your BDP {this.instructionsSeries[0].strName} sets!</h2>
					<p className="bdp-series-main__announcement-intro bdp-series-main__announcement-intro--finalists-landing">The sets have shipped out and building instructions are now available.{this.instructionsSeries[0].idSeries == 1 ? '*' : ''}</p>
					{this.instructionsSeries[0].idSeries == 1 ? <p className="l-margin-top--sm">*APAC region shipping delays: Sets will start shipping in mid-July and August</p> : null}
					<section className="bdp-series-submissions__card-container bdp-series-submissions__card-container--finalists-landing">
						{instructionsCards}
					</section>
					<a href={blapp.url2.getCrowdSeriesUrl(this.instructionsSeries[0].strSlug)} className="btn bg-color--white text-color--darkestBlue text--small-title text--bold bdp-series-main__announcement-link">Go to {this.instructionsSeries[0].strName}<i className="fas fa-long-arrow-right l-margin-left"/></a>
				</section>
			);
		}else{
			return (
				<section className="bdp-series-main__home-block">
					<h1 className="bdp-series-main__announcement-sub bdp-series-main__announcement-sub--finalists-landing text--uppercase">{seriesContent.strName}</h1>
					<CountdownIntroBlock classes="bdp-series-main__announcement-block--landing" series={seriesContent}/>
					<a href={blapp.url2.getCrowdSeriesUrl(seriesContent.strSlug)} className="btn bg-color--white text-color--darkestBlue text--small-title text--bold bdp-series-main__announcement-link">Go to {seriesContent.strName}<i className="fas fa-long-arrow-right l-margin-left"/></a>
				</section>
			);
		}
	}

	renderActivity(slug) {
		const seriesContent = this.crowdfundingSeries.length ? this.crowdfundingSeries[0] : this.preCrowdfundingSeries.length ? this.preCrowdfundingSeries[0] : this.series[0];
		const crossPromoContent = {strActivityIntroBlurb: seriesContent.strActivityIntroBlurb, strActivityWinnersText: seriesContent.strActivityWinnersText, strActivityWinnersTitle: seriesContent.strActivityWinnersTitle}

		return (
			<section className="bdp-series-main__cross-promotion">
				<StudioActivityContent slug={slug} activity={seriesContent.dmActivity} crossPromotion={crossPromoContent}/>
			</section>
		);
	}

	renderPastSeries() {
		if(this.crowdfundingSeries.length) {
			return this.series.filter(series => series.idSeries != this.crowdfundingSeries[0].idSeries).filter(series => !this.isUpcoming(series)).map(series => this.renderSeriesBlock(series));
		}else if(this.preCrowdfundingSeries.length) {
			return this.series.filter(series => series.idSeries != this.preCrowdfundingSeries[0].idSeries).filter(series => !this.isUpcoming(series)).map(series => this.renderSeriesBlock(series));
		}else if(this.designsAnnouncedSeries.length) {
			return this.series.filter(series => series.idSeries != this.designsAnnouncedSeries[0].idSeries).filter(series => !this.isUpcoming(series)).map(series => this.renderSeriesBlock(series));
		}else{
			return this.series.slice(1).filter(series => !this.isUpcoming(series)).map(series => this.renderSeriesBlock(series));
		}
	}

	renderSeriesBlock(series) {
		const seriesFinalists = this.finalists.data.submissions.filter(submission => submission.dmBDPSeries.idSeries == series.idSeries);
		const finalistCards 	= seriesFinalists.map(submission => <BDPSubmissionCard data={submission} key={submission.idSubmission} hasVoting={true} classes="bdp-series-submissions__card"/>);
		const seriesContent 	= this.series[this.series.findIndex(seriesX => seriesX.idSeries == series.idSeries)];

		if(seriesFinalists.length && series.phase != 'CLOSED' && series.udtDesignsAnnounced <= blapp.config.server_time) {
			return (
				<section className="bdp-series-main__home-block">
					<h1 className="bdp-series-main__announcement-sub bdp-series-main__announcement-sub--finalists-landing text--uppercase">{seriesContent.strName}</h1>
					<h2 className="bdp-series-main__announcement-title l-margin-bottom--sm">Our five {seriesContent.strName} finalists!</h2>
					<p className="bdp-series-main__announcement-intro bdp-series-main__announcement-intro--finalists-landing">These designs are chosen for Crowdfunding on {bdpDateFormatLong(seriesContent.udtCrowdFundingStart)} Pacific time.</p>
					<section className="bdp-series-submissions__card-container bdp-series-submissions__card-container--finalists-landing">
						{finalistCards}
					</section>
					<a href={blapp.url2.getCrowdSeriesUrl(seriesContent.strSlug)} className="btn bg-color--white text-color--darkestBlue text--small-title text--bold bdp-series-main__announcement-link">Go to {seriesContent.strName}<i className="fas fa-long-arrow-right l-margin-left"/></a>
				</section>
			);
		}else{
			return this.renderSeriesAnnouncement(series.idSeries);
		}
	}

	renderSeriesAnnouncement(seriesNumber) {
		const seriesContent = this.series[this.series.findIndex(series => series.idSeries == seriesNumber)];
		
		const highlightSeriesContent = this.crowdfundingSeries.length ? this.crowdfundingSeries[0] : this.preCrowdfundingSeries.length ? this.preCrowdfundingSeries[0] : this.series[0];
		const isInstructionsSeries = blapp.config.server_time >= moment(seriesContent.udtProductionStart).subtract(7, 'days') && blapp.config.server_time <= moment(seriesContent.udtProductionStart).add(1, 'month');
		const showInstructions = this.crowdfundingSeries.length != 0 || this.preCrowdfundingSeries.length != 0 || this.finalists.data.submissions.filter(submission => submission.dmBDPSeries.idSeries == highlightSeriesContent.idSeries).length != 0;

		if(seriesContent.phase != 'CLOSED' || (isInstructionsSeries && showInstructions)) {
			return (
				<section className="bdp-series-main__home-block">
					<h1 className="bdp-series-main__announcement-sub bdp-series-main__announcement-sub--finalists-landing text--uppercase">{seriesContent.strName}</h1>
					<CountdownIntroBlock classes="bdp-series-main__announcement-block--landing" series={seriesContent}/>
					<a href={blapp.url2.getCrowdSeriesUrl(seriesContent.strSlug)} className="btn bg-color--white text-color--darkestBlue text--small-title text--bold bdp-series-main__announcement-link">Go to {seriesContent.strName}<i className="fas fa-long-arrow-right l-margin-left"/></a>
				</section>
			);
		}
	}

	renderUpcomingCrowdfunding() {
		const upcomingSeries = this.series.filter(series => this.isUpcoming(series));

		if(upcomingSeries.length) {
			const upcomingSeriesItems = [...upcomingSeries].reverse().map(series => {
				const seriesFinalists = this.finalists.data.submissions.filter(submission => submission.dmBDPSeries.idSeries == series.idSeries);
				
				const finalistImages = seriesFinalists.map(finalist => {
					return (
						<div>
							<div className="bdp-submission-card__image" style={{backgroundImage: `url(${finalist.arrImages[1].dmThumbnail.url})`}}>
								<div className="bdp-submission-card__image-internal" style={{backgroundImage: `url(${finalist.arrImages[0].dmThumbnail.url})`}}>
									<img className="l-hide" src={finalist.arrImages[0].dmThumbnail.url} alt={finalist.strSubmissionName}/>
								</div>
							</div>
						</div>
					);
				});

				return (
					<article className="bdp-series-card card">
						<div className="bdp-series-card__internal overflow-hidden card__internal card__internal--shadow">
							<Slider className="bdp-series-card__images" {...this.slickSettings}>
								{finalistImages.sort(() => Math.random() - 0.5)}
							</Slider>
							<div className="bdp-series-card__main">
								<h2 className="text--title text--bold">{series.strName}</h2>
								<p className="l-margin-bottom">Pre-ordering starts on {bdpDateFormatLong(series.udtCrowdFundingStart)} Pacific.</p>
								<a className="btn text-color--primaryBlue text--bold l-inline-block" href={blapp.url2.getCrowdSeriesUrl(series.strSlug)}>Go to {series.strName}<i className="fas fa-long-arrow-right l-margin-left"/></a>
							</div>
						</div>
					</article>
				);
			});

			if(upcomingSeries.length > 1) {
				return (
					<section className="bdp-series-main__home-block">
						<h2 className="bdp-series-main__announcement-title bdp-series-main__announcement-title--finalists-landing">Upcoming crowdfunding</h2>
						<div className="bdp-series-main__upcoming">
							<Slider className="bdp-video-gallery__video-slider" ref={upcomingGallery => this.upcomingGallery = upcomingGallery} {...this.slickSettingsUpcoming}>
								{upcomingSeriesItems}
							</Slider>
							<div className={`bdp-video-gallery__pagination ${upcomingSeriesItems.length <= 2 ? 'bdp-video-gallery__pagination--one-page' : ''}`}>
								<ul className="slick-dots l-margin-top--null bdp-video-gallery__pagination-item bdp-video-gallery__pagination-item--large-screen">
									{this.renderPagination(upcomingSeriesItems.length - 1, 2)}
								</ul>
								<ul className="slick-dots l-margin-top--null bdp-video-gallery__pagination-item bdp-video-gallery__pagination-item--small-screen">
									{this.renderPagination(upcomingSeriesItems.length - 1, 1)}
								</ul>
								<div className="l-flex">
									<button className="bdp-model__whats-next-slider-button l-margin-right" disabled={this.state.activeSlide == 0} onClick={() => this.prevSlide()}>
										<i className="fas fa-chevron-left"/>
									</button>
									<button className="bdp-model__whats-next-slider-button bdp-video-gallery__pagination-item bdp-video-gallery__pagination-item--small-screen" disabled={this.state.activeSlide == upcomingSeriesItems.length - 1} onClick={() => this.nextSlide()}>
										<i className="fas fa-chevron-right"/>
									</button>
									<button className="bdp-model__whats-next-slider-button bdp-video-gallery__pagination-item bdp-video-gallery__pagination-item--large-screen" disabled={this.state.activeSlide == upcomingSeriesItems.length - (2 - (upcomingSeriesItems.length % 2 === 0 ? 0 : 1))} onClick={() => this.nextSlide()}>
										<i className="fas fa-chevron-right"/>
									</button>
								</div>
							</div>
						</div>
					</section>
				);
			}else{
				return (
					<section className="bdp-series-main__home-block">
						<h2 className="bdp-series-main__announcement-title bdp-series-main__announcement-title--finalists-landing">Upcoming crowdfunding</h2>
						<div className="bdp-series-main__upcoming bdp-video-gallery__video-slider">
							{upcomingSeriesItems}
						</div>
					</section>
				);
			}
		}
	}

	renderPastPrograms() {
		return (
			<section className="bdp-past-programs">
				<h1 className="text--xl-title text--bold l-margin-bottom">Learn about our test builds</h1>
				<p className="l-margin-bottom--xl text-color--secondary text--small-title">We’ve had several pilot programs over the years that helped us learn and grow.</p>
				<a className="btn btn--white text--small-title bdp-past-programs__cta" href={blapp.url2.getCrowdProjectPastUrl()}>View past programs<i className="fas fa-long-arrow-right l-margin-left"/></a>
			</section>
		)
	}

	renderPagination(amount, step) {
		let pagination = [];

		for(let i = 0; i <= amount; i += step) {
				pagination.push(
					<li key={i} className={this.state.activeSlide == i ? 'slick-active' : ''}>
						<button onClick={() => this.changeSlide(i)}>{i}</button>
					</li>
				);
		}

		return pagination;
	}

	changeSlide(slide) {
		this.setState({activeSlide: slide});

		this.upcomingGallery.slickGoTo(slide);
	}

	nextSlide() {
		this.upcomingGallery.slickNext();
	}
	prevSlide() {
		this.upcomingGallery.slickPrev();
	}

	isUpcoming(series) {
		const thirtyDaysLater = new Date(moment(series.udtDesignsAnnounced).add(30, 'days')).getTime();
		const serverTime = blapp.config.server_time;

		return thirtyDaysLater <= serverTime && serverTime <= series.udtCrowdFundingAnnouncement;
	}

	toggleInstructionsModal(id) {
		if(id != null) {
			this.setState({showInstructions: true, instructions: this.instructions[this.instructions.findIndex(item => item.idSubmission == id)]});		
		}else{
			this.setState({showInstructions: false})
		}

		blapp.screen.toggleScroll(!this.state.showInstructions);
	}
};

document.addEventListener( "DOMContentLoaded", 
	function() {
		var	elem	=	ReactDOM.render(
							<CrowdLanding blctx={{parent: null, idx:0}} />
						,	document.getElementById( 'bl-crowd' )
						);
		blapp.refs.register( "main", elem );
	}
);
 

